// Define enums for status, plan, and platform
export enum MerchantStatus {
  ALLOWLISTED = 'ALLOWLISTED',
  REGISTERED = 'REGISTERED',
  INSTALLED = 'INSTALLED',
  UNINSTALLED = 'UNINSTALLED',
  INACTIVE = 'INACTIVE',
}

export const MerchantStatusDisplayNames: { [key in MerchantStatus]: string } = {
  [MerchantStatus.ALLOWLISTED]: 'Allowlisted',
  [MerchantStatus.REGISTERED]: 'Registered',
  [MerchantStatus.INSTALLED]: 'Installed',
  [MerchantStatus.UNINSTALLED]: 'Uninstalled',
  [MerchantStatus.INACTIVE]: 'Inactive',
}

export enum MerchantPlan {
  NONE = 'NONE',
  BASE = 'BASE',
  INFLUENCER = 'INFLUENCER',
  ENTERPRISE = 'ENTERPRISE',
  ENTERPRISE_INFLUENCER = 'ENTERPRISE_INFLUENCER',
}

export const MerchantPlanDisplayNames: { [key in MerchantPlan]: string } = {
  [MerchantPlan.NONE]: 'None',
  [MerchantPlan.BASE]: 'Insights (Deprecated)',
  [MerchantPlan.INFLUENCER]: 'Influencer Storefronts',
  [MerchantPlan.ENTERPRISE]: 'Paid Media',
  [MerchantPlan.ENTERPRISE_INFLUENCER]: 'Paid Media + Influencer Storefronts',
}

export enum MerchantPlatform {
  SHOPIFY = 'SHOPIFY',
  SALESFORCE = 'SALESFORCE_COMMERCE_CLOUD',
  FEED = 'FEED'
}

export const MerchantPlatformDisplayNames: { [key in MerchantPlatform]: string } = {
  [MerchantPlatform.SHOPIFY]: 'Shopify',
  [MerchantPlatform.SALESFORCE]: 'Salesforce',
  [MerchantPlatform.FEED]:'Feed'
}

export const MerchantPlatformDomains: { [key in MerchantPlatform]: string } = {
  [MerchantPlatform.SHOPIFY]: '.myshopify.com',
  [MerchantPlatform.SALESFORCE]: '',
  [MerchantPlatform.FEED]: ''
}

// GetMerchantsParams is a type that represents the query params to the getMerchants API
export type GetMerchantsParams = {
  limit: number,
  offset?: number

  status?: MerchantStatus
  plan?: MerchantPlan
  platform?: MerchantPlatform
}

export enum MerchantCurrencyCode {
  USD = 'USD',
  GBP = 'GBP',
  CAD = 'CAD',
  EUR = 'EUR',
}

export type NewMerchant = {
  shop: string
  status: MerchantStatus
  plan: MerchantPlan
  platform: MerchantPlatform
  isCartless: boolean
  affiliateNetworkConfig: AffiliateNetworkConfig
  currencyCode?: MerchantCurrencyCode
}

// Update the Merchant type to use these enums
export type Merchant = NewMerchant & {
  createdAt: number
  updatedAt: number
}

export type AffiliateNetworkConfig = {
  type: MerchantAffiliateNetwork
  impact?: ImpactConfig
  ciq?: CIQConfig
  socialSnowball?: SocialSnowballConfig
  everflow?: EverflowConfig
}

export type ImpactConfig = {
  programId: string
  accountSid: SDXSecret
  apiKey: SDXSecret
}

export type CIQConfig = {
  apiKey: SDXSecret
  campaignId: string
  partnerId: string
}

export type SocialSnowballConfig = {
  email: string
  password: SDXSecret
}

export type EverflowConfig = {
  networkApiKey: SDXSecret
  offerId: string
}

export type SDXSecret = {
  transportEncrypted: string
}

export enum MerchantAffiliateNetwork {
  NONE = 'NONE',
  IMPACT = 'IMPACT',
  CIQ = 'CIQ',
  SOCIAL_SNOWBALL = 'SOCIAL_SNOWBALL',
  EVERFLOW = 'EVERFLOW'
}

export const MerchantAffiliateNetworkDisplayNames: { [key in MerchantAffiliateNetwork]: string } = {
  [MerchantAffiliateNetwork.IMPACT]: 'Impact',
  [MerchantAffiliateNetwork.CIQ]: 'Creator IQ',
  [MerchantAffiliateNetwork.SOCIAL_SNOWBALL]: 'Social Snowball',
  [MerchantAffiliateNetwork.EVERFLOW]: 'Everflow',
  [MerchantAffiliateNetwork.NONE]: 'None'
}
